"use client";

import { useEffect, useRef } from "react";
import Icon from "@/components/ui/AppIcon";

const industries = [
  { icon: "CogIcon", label: "Manufacturing" },
  { icon: "ShoppingBagIcon", label: "Retail & E-Commerce" },
  { icon: "GlobeAltIcon", label: "Import & Export" },
  { icon: "BuildingOffice2Icon", label: "Corporate Enterprises" },
  { icon: "TruckIcon", label: "Supply Chain" },
  { icon: "CubeIcon", label: "Warehousing" },
  { icon: "ChartPieIcon", label: "Financial Services" },
  { icon: "BriefcaseIcon", label: "Professional Services" },
];

// Duplicate for seamless marquee
const industriesDouble = [...industries, ...industries];

export default function IndustriesSection() {
  const sectionRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("visible");
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.15 }
    );
    const el = sectionRef.current;
    if (el) el.querySelectorAll(".reveal").forEach((i) => observer.observe(i));
    return () => observer.disconnect();
  }, []);

  return (
    <section ref={sectionRef} className="relative py-28 bg-[#0C1B33] overflow-hidden">
      <div className="max-w-7xl mx-auto px-6 mb-14 text-center">
        <p className="reveal text-[11px] font-display uppercase tracking-[0.2em] text-gold mb-3">
          Sectors We Serve
        </p>
        <h2 className="reveal delay-100 text-4xl md:text-5xl font-display font-700 text-cream tracking-tight">
          Industries We Serve
        </h2>
        <p className="reveal delay-200 text-[18px] font-body font-500 text-cream/80 mt-4 max-w-lg mx-auto leading-[1.75]">
          Our operational expertise spans diverse industries — from manufacturing floors to global e-commerce platforms.
        </p>
      </div>

      {/* Marquee */}
      <div className="marquee-mask overflow-hidden">
        <div className="flex marquee-track gap-4" style={{ width: "max-content" }}>
          {industriesDouble.map((ind, i) => (
            <div
              key={`${ind.label}-${i}`}
              className="flex-shrink-0 flex items-center gap-3 px-6 py-4 rounded-xl border border-[rgba(184,134,11,0.25)] bg-[rgba(26,51,88,0.4)] backdrop-blur-sm hover:border-gold/60 transition-colors group"
            >
              <div className="w-8 h-8 rounded-lg bg-[rgba(184,134,11,0.15)] flex items-center justify-center">
                <Icon
                  name={ind.icon as "CogIcon"}
                  size={16}
                  className="text-gold"
                />
              </div>
              <span className="text-[15px] font-display font-600 uppercase tracking-wider text-cream/85 whitespace-nowrap group-hover:text-cream transition-colors">
                {ind.label}
              </span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}